(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hh-brand-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hh-brand-film')) {
    customElements.define('hh-brand-film', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        this.initialized = true;
        button.hidden = false;
        button.addEventListener('click', async () => {
          try {
            await video.play();
            button.hidden = true;
            video.focus();
          } catch {
            button.hidden = false;
          }
        });
        video.addEventListener('play', () => { button.hidden = true; });
        video.addEventListener('ended', () => { button.hidden = false; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
